export default [
  {
    path: "finance/voucher-list",
    name: "VoucherList",
    component: () => import("../pages/finance/VoucherList.vue"),
    meta: {
      title: "凭证明细列表",
    },
  },
  {
    path: "finance/voucher-summary-list",
    name: "VoucherSummaryList",
    component: () => import("../pages/finance/VoucherSummaryList.vue"),
    meta: {
      title: "凭证汇总列表",
    },
  },
  {
    path: "finance/intermediate",
    name: "IntermediateTable",
    component: () => import("../pages/finance/IntermediateTable.vue"),
    meta: {
      title: "业财中间表",
    },
  },
  {
    path: "finance/subject-month",
    name: "SubjectrMonth",
    component: () => import("../pages/finance/SubjectMonth.vue"),
    meta: {
      title: "科目余额月汇总",
    },
  },
  {
    path: "finance/subject-day",
    name: "SubjectrDay",
    component: () => import("../pages/finance/SubjectDay.vue"),
    meta: {
      title: "科目余额日汇总",
    },
  },
  {
    path: "finance/subject-month-supply",
    name: "SubjectrMonthSupply",
    component: () => import("../pages/finance/SupplySubject.vue"),
    meta: {
      title: "商家科目余额",
    },
  },
  {
    path: "finance/subject-month-user",
    name: "SubjectrMonthUser",
    component: () => import("../pages/finance/UserSubject.vue"),
    meta: {
      title: "用户科目余额",
    },
  },
  {
    path: "finance/voucher-subject-list",
    name: "VoucherSubjectList",
    component: () => import("../pages/finance/VoucherList.vue"),
    meta: {
      title: "科目明细列表",
    },
  },
  {
    path: "finance/order-voucher",
    name: "OrderVoucher",
    component: () => import("../pages/finance/OrderVoucher.vue"),
    meta: {
      title: "订单凭证明细",
    },
  },
  {
    path: "finance/order-subject",
    name: "OrderSubject",
    component: () => import("../pages/finance/OrderSubject.vue"),
    meta: {
      title: "订单科目汇总",
    },
  },
  {
    path: "finance/trade-bills",
    name: "TradeBills",
    component: () => import("../pages/finance/TradeBills.vue"),
    meta: {
      title: "交易流水对账",
    },
  },
  {
    path: "finance/cash-bills",
    name: "CashBills",
    component: () => import("../pages/finance/CashBills.vue"),
    meta: {
      title: "提现流水对账",
    },
  },
  {
    path: "finance/stock-daily-report",
    name: "StockDailyReport",
    component: () => import("../pages/finance/StockDailyReport.vue"),
    meta: {
      title: "库存日报表",
    },
  },
  {
    path: "freight/detail",
    name: "FreightDetail",
    component: () => import("../pages/finance/FreightDetail.vue"),
    meta: {
      title: "运费明细",
    },
  },
  {
    path: "freight/split",
    name: "FreightSplit",
    component: () => import("../pages/finance/FreightSplit.vue"),
    meta: {
      title: "运费分账",
    },
  },
];



// WEBPACK FOOTER //
// ./src/router/finance.js